import React from 'react';
import FraudSecurityArchiveSection from '../../../sections/AdminDashboard/SecurityFraud/FraudSecurityArchive';

const FraudSecurityArchive = () => {
  return <FraudSecurityArchiveSection />;
};

export default FraudSecurityArchive;
